import React from 'react';

import styled from 'styled-components';

import LoaderRibbed from 'components/lib/LoaderRibbed';

import EnableDigestPrompt from './EnableDigestPrompt';

const Container = styled.div`
  padding: 20px 0 30px;
`;

const LoaderContainer = styled(Container)`
  display: flex;
  justify-content: center;
`;

const Message = styled(Container)`
  color: var(--text-secondary);
  font-size: 14px;
`;

type Props = {
  isLoading: boolean;
  isError: boolean;
  digestEnabled?: boolean;
  hasDigest: boolean;
  emptyMessage: string;
};

const DigestSectionState = ({ isLoading, isError, digestEnabled, hasDigest, emptyMessage }: Props) => {
  if (isLoading) {
    return (
      <LoaderContainer>
        <LoaderRibbed active />
      </LoaderContainer>
    );
  }
  if (isError) {
    return (
      <Message data-test-id="cmi-digest-section-error">The digest could not be loaded. Please try again later.</Message>
    );
  }
  if (digestEnabled === false) {
    return (
      <Container>
        <EnableDigestPrompt />
      </Container>
    );
  }
  if (!hasDigest) {
    return <Message data-test-id="cmi-digest-section-empty">{emptyMessage}</Message>;
  }
  return null;
};

export default DigestSectionState;
